import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enCommon from "./locales/en/common.json";
import enValidation from "./locales/en/validation.json";
import enMenus from "./locales/en/menus.json";
import enAccount from "./locales/en/pages/account.json";
import enAdmin from "./locales/en/pages/admin.json";
import enFileList from "./locales/en/pages/file-list.json";
import enHome from "./locales/en/pages/home.json";
import enIndex from "./locales/en/pages/index.json";
import enJobList from "./locales/en/pages/job-list.json";
import enNotificationList from "./locales/en/pages/notification-list.json";
import enProjectList from "./locales/en/pages/project-list.json";
import enProteinEditor from "./locales/en/pages/protein-editor.json";
import enSequenceViewer from "./locales/en/pages/sequence-viewer.json";
import enComponents from "./locales/en/components.json";
import enLayouts from "./locales/en/layouts.json";

import zhCommon from "./locales/zh/common.json";
import zhValidation from "./locales/zh/validation.json";
import zhMenus from "./locales/zh/menus.json";
import zhAccount from "./locales/zh/pages/account.json";
import zhAdmin from "./locales/zh/pages/admin.json";
import zhFileList from "./locales/zh/pages/file-list.json";
import zhHome from "./locales/zh/pages/home.json";
import zhIndex from "./locales/zh/pages/index.json";
import zhJobList from "./locales/zh/pages/job-list.json";
import zhNotificationList from "./locales/zh/pages/notification-list.json";
import zhProjectList from "./locales/zh/pages/project-list.json";
import zhProteinEditor from "./locales/zh/pages/protein-editor.json";
import zhSequenceViewer from "./locales/zh/pages/sequence-viewer.json";
import zhComponents from "./locales/zh/components.json";
import zhLayouts from "./locales/zh/layouts.json";

const resources = {
  en: {
    common: enCommon,
    validation: enValidation,
    menus: enMenus,
    "pages.account": enAccount,
    "pages.admin": enAdmin,
    "pages.fileList": enFileList,
    "pages.home": enHome,
    "pages.index": enIndex,
    "pages.jobList": enJobList,
    "pages.notificationList": enNotificationList,
    "pages.projectList": enProjectList,
    "pages.proteinEditor": enProteinEditor,
    "pages.sequenceViewer": enSequenceViewer,
    components: enComponents,
    layouts: enLayouts,
  },
  zh: {
    common: zhCommon,
    validation: zhValidation,
    menus: zhMenus,
    "pages.account": zhAccount,
    "pages.admin": zhAdmin,
    "pages.fileList": zhFileList,
    "pages.home": zhHome,
    "pages.index": zhIndex,
    "pages.jobList": zhJobList,
    "pages.notificationList": zhNotificationList,
    "pages.projectList": zhProjectList,
    "pages.proteinEditor": zhProteinEditor,
    "pages.sequenceViewer": zhSequenceViewer,
    components: zhComponents,
    layouts: zhLayouts,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    defaultNS: "common",
    ns: [
      "common",
      "validation",
      "menus",
      "pages.account",
      "pages.admin",
      "pages.fileList",
      "pages.home",
      "pages.index",
      "pages.jobList",
      "pages.notificationList",
      "pages.projectList",
      "pages.proteinEditor",
      "pages.sequenceViewer",
      "components",
      "layouts",
    ],
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export default i18n;
